import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseConfigAdjustmentReasonActivity extends Component {

    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Accounting/InventoryAdjustmentReason/InventoryAdjustmentReasonBrowser")
    }

    render() {
        return (
            <Activity 
                name="InventoryAdjustmentReason"
                RenderedComponent={this.RenderedComponent}
                context="InventoryAdjustmentReason"
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseConfigAdjustmentReasonActivity)
